// extracted by mini-css-extract-plugin
export var legalStaticPage = "h_L";